document.addEventListener("DOMContentLoaded", function () {
  const lazyImages = document.querySelectorAll(".lazy-load");

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target;
        img.src = img.dataset.src;
        img.removeAttribute("data-src");
        observer.unobserve(img);
      }
    });
  }, { rootMargin: "200px" });

  lazyImages.forEach(img => observer.observe(img));
});

// const pullToRefresh = document.querySelector('.template_index');
// let touchstartY = 0;
// document.addEventListener('touchstart', e => {
//   touchstartY = e.touches[0].clientY;
// });
// document.addEventListener('touchmove', e => {
//   const touchY = e.touches[0].clientY;
//   const touchDiff = touchY - touchstartY;
//   if (touchDiff > 0 && window.scrollY === 0) {
//     pullToRefresh.classList.add('visible');
//     e.preventDefault();
//   }
// });
// document.addEventListener('touchend', e => {
//   if (pullToRefresh.classList.contains('visible')) {
//     pullToRefresh.classList.remove('visible');
//     location.reload();
//   }
// });

// document.addEventListener("DOMContentLoaded", function () {
//   var searchElement = document.querySelector(".input-link_custom");
//   var sectionHeader = document.querySelector(".section-header");
//   var closeButton = document.querySelector(".search-modal__close-button");

//   if (searchElement) {
//     searchElement.addEventListener("click", function () {
//       var detailsElement = document.querySelector(
//         "#search_bar > details-modal > details"
//       );
//       if (detailsElement) {
//         detailsElement.setAttribute("open", "true");
//         sectionHeader?.classList.add("search-modal__open");
//       }
//     });
//   }

//   if (closeButton) {
//     closeButton.addEventListener("click", function () {
//       sectionHeader?.classList.remove("search-modal__open");
//     });
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  // === SELECT ELEMENTS ===
  const searchElement = document.querySelector(".input-link_custom");
  const sectionHeader = document.querySelector(".section-header");
  const detailsElement = document.querySelector("#search_bar > details-modal > details");
  const closeButton = document.querySelector(".search-modal__close-button");
  const searchInput = document.querySelector("#search_bar input[type='search']");

  if (!searchElement || !detailsElement) return;

  // === OPEN SEARCH MODAL ===
  function openSearchModal(evt) {
    // Prevent normal navigation unless modifier keys are used
    if (evt && (evt.metaKey || evt.ctrlKey || evt.shiftKey || evt.altKey)) return;
    if (evt) evt.preventDefault();

    detailsElement.setAttribute("open", "true");
    sectionHeader?.classList.add("search-modal__open");
    searchElement.setAttribute("aria-expanded", "true");

    // focus the input after the modal animates open
    setTimeout(() => {
      try {
        searchInput?.focus({ preventScroll: true });
      } catch {
        searchInput?.focus();
      }
    }, 150);
  }

  // === CLOSE SEARCH MODAL ===
  function closeSearchModal() {
    detailsElement.removeAttribute("open");
    sectionHeader?.classList.remove("search-modal__open");
    searchElement.setAttribute("aria-expanded", "false");

    // Return focus to the "Find" link for accessibility
    setTimeout(() => {
      searchElement.focus();
    }, 100);
  }

  // === EVENT LISTENERS ===
  searchElement.addEventListener("click", openSearchModal);

  // keyboard activation (Enter / Space)
  searchElement.addEventListener("keydown", function (evt) {
    const key = evt.key || evt.keyCode;
    if (key === "Enter" || key === " " || key === "Spacebar" || key === 13 || key === 32) {
      openSearchModal(evt);
    }
  });

  closeButton?.addEventListener("click", closeSearchModal);

  // allow Esc key to close the modal
  document.addEventListener("keydown", function (evt) {
    if (evt.key === "Escape" && detailsElement.hasAttribute("open")) {
      closeSearchModal();
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const searchInput = document.querySelector("#Search-In-Modal");
  if (!searchInput) return;

  const originalPH = searchInput.getAttribute("placeholder") || "";
  let clearedOnce = false;

  // Keep placeholder on focus (until user types)
  searchInput.addEventListener("focus", () => {
    if (!clearedOnce && searchInput.value === "") {
      searchInput.setAttribute("placeholder", originalPH);
    }
  });

  // First keystroke → remove placeholder
  searchInput.addEventListener("input", () => {
    if (!clearedOnce) {
      searchInput.setAttribute("placeholder", "");
      clearedOnce = true;
    }
  });

  // If empty on blur, restore placeholder + allow clearing again next time
  searchInput.addEventListener("blur", () => {
    if (searchInput.value === "") {
      searchInput.setAttribute("placeholder", originalPH);
      clearedOnce = false;
    }
  });
});




document.addEventListener('DOMContentLoaded', function () {
  function adjustFontSize() {
    const elements = document.querySelectorAll(
      "h1, h2, h3, h4, h5, h6, .h0, .h1, .h2, .h3, .h4, .h5, body, p, a, span, small"
    );

    if (window.innerWidth >= 1900) {
      elements.forEach((element) => {
        if (!element.dataset.originalFontSize) {
          const currentFontSize = parseFloat(window.getComputedStyle(element).fontSize);
          element.dataset.originalFontSize = currentFontSize;
        }
        const originalFontSize = parseFloat(element.dataset.originalFontSize);
        element.style.fontSize = `${originalFontSize + 2}px`;
      });
    } else {
      elements.forEach((element) => {
        if (element.dataset.originalFontSize) {
          element.style.fontSize = `${element.dataset.originalFontSize}px`;
        } else {
          element.style.fontSize = "";
        }
      });
    }
  }

  adjustFontSize();
  window.addEventListener("resize", adjustFontSize);
});


$(".card--card, .facets, .header, .loading-overlay").click(function () {
  $("#ProductGridContainer").removeClass("blur");
  $("body").removeClass("blurr");
});



$(document).on("click", function (e) {
  if (
    (!e.target.closest(".newonlickheading") &&
      !e.target.closest(".facets__display")) ||
    e.target.closest(".products_count_class")
  ) {
    $(".facets__display").slideUp();
    $('.sameclass').removeClass('active');
  }
});


////////////////////////////// Size Variant //////////////////////////////
function ensureGlobalModal() {
  let globalModal = document.querySelector('#global-size-variant-modal');

  if (!globalModal) {
    globalModal = document.createElement('div');
    globalModal.id = 'global-size-variant-modal';
    globalModal.className = 'size-variant-modal';
    globalModal.setAttribute('data-hidden', 'true');
    globalModal.innerHTML = `
      <div class="overlay__size-variants"></div>
      <div class="size_varint_cart"></div>
    `;
    document.body.appendChild(globalModal);
  }

  return globalModal;
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('.product-add-to-cart__button');
  if (!button) return;

  const productContainer = button.closest('.grid__item');
  if (!productContainer) return;

  const sizeVariantCart = productContainer.querySelector('.size_varint_cart');
  const globalModal = ensureGlobalModal();
  const overlay = globalModal.querySelector('.overlay__size-variants');
  const globalCart = globalModal.querySelector('.size_varint_cart');

  if (sizeVariantCart && globalCart) {
    globalCart.innerHTML = sizeVariantCart.innerHTML;
    openSizeVariantModal(globalModal, productContainer);
  }
});

function openSizeVariantModal(modal, productContainer) {
  if (!modal || !productContainer) return;

  const overlay = modal.querySelector('.overlay__size-variants');
  const cart = modal.querySelector('.size_varint_cart');

  modal.setAttribute('data-hidden', 'false');

  document.body.style.overflow = 'hidden';

  if (window.innerWidth >= 750) {
    productContainer.appendChild(modal);
  } else {
    document.body.appendChild(modal);
  }

  requestAnimationFrame(() => {
    overlay.classList.add('active');
    slideDown(cart, 500);
  });

  closeOnOverlayClick(overlay);
  closeOnMouseLeave(modal);
  enableSwipeToClose(cart);
}

function closeOnOverlayClick(overlay) {
  overlay.removeEventListener('click', resetSizeVariantModal);
  overlay.addEventListener('click', resetSizeVariantModal);
}

function closeOnMouseLeave(modal) {
  modal.removeEventListener('mouseleave', handleMouseLeave);
  modal.addEventListener('mouseleave', handleMouseLeave);
}

function handleMouseLeave() {
  if (window.innerWidth >= 1024) resetSizeVariantModal();
}

function enableSwipeToClose(element) {
  // let startY = 0;
  // let currentY = 0;
  // let isDragging = false;
  // let maxDelta = 0;
  let startY = 0, currentY = 0, isDragging = false, maxDelta = 0;

  const modal = document.querySelector('#global-size-variant-modal');
  const overlay = modal?.querySelector('.overlay__size-variants');

  element.style.transition = 'transform 0.3s ease';
  if (overlay) overlay.style.transition = 'opacity 0.3s ease';

  function onTouchStart(e) {
    startY = e.touches[0].clientY;
    isDragging = true;
    requestAnimationFrame(() => {
      maxDelta = element.offsetHeight;
      element.style.transition = 'none';
      if (overlay) overlay.style.transition = 'none';
    });
    // maxDelta = element.offsetHeight;
    // element.style.transition = 'none';
    // if (overlay) overlay.style.transition = 'none';
  }

  function onTouchMove(e) {
    if (!isDragging) return;
    currentY = e.touches[0].clientY;
    const deltaY = currentY - startY;

    // if (deltaY > 0) {
    //   element.style.transform = `translateY(${deltaY}px)`;

    //   // Adjust overlay opacity
    //   // const maxDelta = element.offsetHeight;
    //   const opacity = Math.max(0, 1 - deltaY / maxDelta);
    //   if (overlay) overlay.style.opacity = opacity.toFixed(2);
    // }
    requestAnimationFrame(() => {
      if (deltaY > 0) {
        element.style.transform = `translateY(${deltaY}px)`;
        const opacity = Math.max(0, 1 - deltaY / maxDelta);
        if (overlay) overlay.style.opacity = opacity.toFixed(2);
      }
    });
  }

  function onTouchEnd() {
    if (!isDragging) return;
    isDragging = false;

    const deltaY = currentY - startY;
    // const threshold = element.offsetHeight * 0.5;
    const threshold = maxDelta * 0.5;

    element.style.transition = 'transform 0.3s ease';
    if (overlay) overlay.style.transition = 'opacity 0.3s ease';

    if (deltaY > threshold) {
      element.style.transform = `translateY(100%)`;
      if (overlay) overlay.style.opacity = '0';

      setTimeout(() => {
        resetSizeVariantModal();
        element.style.transform = '';
        if (overlay) overlay.style.opacity = '';
      }, 300);
    } else {
      element.style.transform = `translateY(0)`;
      if (overlay) overlay.style.opacity = '1';
    }
  }

  // Remove any previous listeners to avoid duplicates
  element.removeEventListener('touchstart', onTouchStart);
  element.removeEventListener('touchmove', onTouchMove);
  element.removeEventListener('touchend', onTouchEnd);

  // Attach new listeners
  element.addEventListener('touchstart', onTouchStart, { passive: true });
  element.addEventListener('touchmove', onTouchMove, { passive: true });
  element.addEventListener('touchend', onTouchEnd);
}




function resetSizeVariantModal() {
  const globalModal = document.querySelector('#global-size-variant-modal');
  if (!globalModal) return;

  globalModal.setAttribute('data-hidden', 'true');

  const overlay = globalModal.querySelector('.overlay__size-variants');
  const globalCart = globalModal.querySelector('.size_varint_cart');

  overlay?.classList.remove('active');
  slideUp(globalCart, 500, () => {
    globalModal.setAttribute('data-hidden', 'true');
    document.body.style.overflow = '';
  });
}

function slideDown(element, duration = 300) {
  element.style.removeProperty('display');
  let display = window.getComputedStyle(element).display;

  if (display === 'none') display = 'block';
  element.style.display = display;

  // const height = element.offsetHeight;
  const height = element.scrollHeight;
  element.style.overflow = 'hidden';
  element.style.height = '0px';
  element.style.transition = `height ${duration}ms ease`;

  requestAnimationFrame(() => {
    element.style.height = `${height}px`;
  });

  setTimeout(() => {
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
  }, duration);
}

function slideUp(element, duration = 300, callback) {
  const height = element.scrollHeight;
  element.style.overflow = 'hidden';
  // const height = element.offsetHeight;
  element.style.height = `${height}px`;
  element.style.transition = `height ${duration}ms ease`;

  requestAnimationFrame(() => {
    element.style.height = '0px';
  });

  setTimeout(() => {
    element.style.display = 'none';
    element.style.removeProperty('height');
    element.style.removeProperty('overflow');
    if (typeof callback === 'function') callback();
  }, duration);
}



$(document).on(
  "click",
  ".all_size_variants li button.size_variant_picker.not_variant_disable",
  function () {
    var variantid = $(this).attr("data-vid");
    var requestedQty = 1;

    // $("#ProductGridContainer").removeClass("blur");
    // $("body").removeClass("blurr");
    try {
      if (typeof resetSizeVariantModal === "function") resetSizeVariantModal();
      var globalModal = document.querySelector("#global-size-variant-modal");
      var globalCart = globalModal ? globalModal.querySelector(".size_varint_cart") : null;
      if (globalCart) globalCart.innerHTML = "";
      $("#ProductGridContainer").removeClass("blur");
      $("body").removeClass("blurr");
    } catch (e) {
      console.warn("Error resetting size variant modal:", e);
    }

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      cache: false,
      data: { id: variantid, quantity: requestedQty },
      dataType: "json",
      success: function (data) {
        $("cart-drawer").addClass("active");
        $("body").css("overflow", "hidden");
        $(".drawer__inner-empty").hide();
        $("cart-drawer").removeClass("is-empty");

        $.get("/cart", function (response) {
          var cartDrawerContent = $(response).find("#CartDrawer").html();
          $("#CartDrawer").html(cartDrawerContent);
          $("#cart-icon-bubble").load(location.href + " #cart-icon-bubble > *");

          if (customElements.get("cart-items")) {
            const cartItemsComponent = document.querySelector("cart-items");
            if (cartItemsComponent) {
              cartItemsComponent.onCartUpdate();
            }
          }
        });
      },
      error: function (err) {
        const errorMessage = err?.responseJSON?.description || "Item could not be added to cart.";
        const $errorWrapper = $(".size_variant__error-message-wrapper");
        const $errorText = $(".size_variant__error-message");

        $errorText.text(errorMessage);
        $errorWrapper.removeAttr("hidden");

        setTimeout(() => {
          $errorWrapper.attr("hidden", true);
        }, 3000);
      },
    });
  }
);
////////////////////////////// Size Variant END //////////////////////////////


$(document).on("click", ".newonlickheading", function () {
  $("#ProductGridContainer").addClass("blur");
  $("body").css("overflow", "hidden");

  var index = $(this).data("indexid");
  var target = $(".child_index" + index);

  if (target.is(":visible")) {
    target.slideUp(function () {
      $("#ProductGridContainer").removeClass("blur");
      $("body").css("overflow", "");
    });
    $('.sameclass').removeClass('active');
  } else {
    $(".facets__display").hide();
    target.slideDown();
  }
});

$(document).on("click", ".clear_buttons", function () {
  $('.sameclass').removeClass('active');
  $("body").css("overflow", "");
})

$(document).on("click", function (e) {
  if (
    !$(e.target).closest('.facets__display, .facets__display-vertical, .newonlickheading, .sameclass').length
  ) {
    $("#ProductGridContainer").removeClass("blur");
    $("body").css("overflow", "");
    $(".facets__display").slideUp();
    $(".sameclass").removeClass("active");
  }
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-toggle-btn').forEach(function (btn) {

    const wrapper = btn.closest('.js-toggle-wrapper') || btn.parentElement;
    const content = wrapper.querySelector('.js-toggle-content');
    const textEl = btn.querySelector('.js-toggle-text') || btn;

    if (!content) return;

    const collapsedHeight =
      content.dataset.collapsedHeight || getComputedStyle(content).maxHeight;

    // Auto-hide button if content is short
    if (content.scrollHeight <= content.offsetHeight) {
      btn.style.display = 'none';
      return;
    }

    btn.addEventListener('click', function () {
      const expanded = content.classList.contains('is-expanded');

      if (expanded) {
        content.style.maxHeight = collapsedHeight;
        content.classList.remove('is-expanded');
        textEl.textContent = 'View more';
      } else {
        content.style.maxHeight = content.scrollHeight + 'px';
        content.classList.add('is-expanded');
        textEl.textContent = 'View less';
      }
    });
  });
});


$(document).ready(function () {
  $(".newsletter-form").on("submit", function (e) {
    var emailInput = $("#NewsletterForm--{{ section.id }}");
    var emailValue = emailInput.val();
    var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailPattern.test(emailValue)) {
      e.preventDefault();
      $("#Newsletter-error--{{ section.id }}")
        .text("Please enter a valid email address.")
        .show();
      emailInput.focus();
      return false;
    } else {
      $("#Newsletter-error--{{ section.id }}").hide();
    }
  });
});

function rangeslider() {
  const minRange = document.getElementById("minRange");
  const maxRange = document.getElementById("maxRange");
  const minValue = document.getElementById("minValue");
  const maxValue = document.getElementById("maxValue");
  const sliderTrack = document.querySelector(".slider-track");
  const gap = 100;

  function updateSliderTrack() {
    if (minRange && maxRange && sliderTrack) {
      const minPercent =
        ((minRange.value - minRange.min) / (minRange.max - minRange.min)) * 100;
      const maxPercent =
        ((maxRange.value - maxRange.min) / (maxRange.max - maxRange.min)) * 100;
      sliderTrack.style.background = `linear-gradient(to right, grey ${minPercent}% , black ${minPercent}% , black ${maxPercent}%, grey ${maxPercent}%)`;
    }
  }

  minRange?.addEventListener("input", function () {
    if (parseInt(maxRange.value) - parseInt(minRange.value) < gap) {
      minRange.value = parseInt(maxRange.value) - gap;
    }
    minValue.textContent = minRange.value;
    updateSliderTrack();
    document.querySelector("#Filter-Price-GTE").value = minRange.value || 0;
    document.querySelector("#Filter-Price-GTE")?.closest(".js-filter")?.querySelector("[data-clabel]")?.classList.remove("disable_btn");
  });

  maxRange?.addEventListener("input", function () {
    if (parseInt(maxRange.value) - parseInt(minRange.value) < gap) {
      maxRange.value = parseInt(minRange.value) + gap;
    }
    maxValue.textContent = maxRange.value;
    updateSliderTrack();
    document.querySelector("#Filter-Price-LTE").value = maxRange.value || 0;
    document.querySelector("#Filter-Price-GTE")?.closest(".js-filter")?.querySelector("[data-clabel]")?.classList.remove("disable_btn");
  });

  updateSliderTrack();
  // mobileMediaAnimationCards();
}
rangeslider();



// function rangeslider() {
//   const minRange = document.getElementById("minRange");
//   const maxRange = document.getElementById("maxRange");
//   const minValue = document.getElementById("minValue");
//   const maxValue = document.getElementById("maxValue");
//   const sliderTrack = document.querySelector(".slider-track");
//   const gap = 100;

//   function updateSliderTrack() {
//     if (minRange && maxRange && sliderTrack) {
//       const minPercent =
//         ((minRange.value - minRange.min) / (minRange.max - minRange.min)) * 100;
//       const maxPercent =
//         ((maxRange.value - maxRange.min) / (maxRange.max - maxRange.min)) * 100;
//       sliderTrack.style.background = `linear-gradient(to right, grey ${minPercent}% , black ${minPercent}% , black ${maxPercent}%, grey ${maxPercent}%)`;
//     }
//   }

//   function updateMin() {
//     if (parseInt(maxRange.value) - parseInt(minRange.value) < gap) {
//       minRange.value = parseInt(maxRange.value) - gap;
//     }
//     minValue.textContent = minRange.value;
//     updateSliderTrack();
//     const gte = document.querySelector("#Filter-Price-GTE");
//     if (gte) gte.value = minRange.value || 0;
//   }

//   function updateMax() {
//     if (parseInt(maxRange.value) - parseInt(minRange.value) < gap) {
//       maxRange.value = parseInt(minRange.value) + gap;
//     }
//     maxValue.textContent = maxRange.value;
//     updateSliderTrack();
//     const lte = document.querySelector("#Filter-Price-LTE");
//     if (lte) lte.value = maxRange.value || 0;
//   }

//   minRange?.addEventListener("input", updateMin);
//   maxRange?.addEventListener("input", updateMax);

//   // ✅ Make clicks on slider track move nearest handle
//   sliderTrack.addEventListener("click", function (e) {
//     const rect = this.getBoundingClientRect();
//     const clickPercent = ((e.clientX - rect.left) / rect.width) * 100;
//     const midpoint = 50; // first 50% controls min, last 50% controls max

//     const rangeMin = Number(minRange.min);
//     const rangeMax = Number(minRange.max);
//     const clickedValue =
//       rangeMin + ((rangeMax - rangeMin) * clickPercent) / 100;

//     if (clickPercent <= midpoint) {
//       // Move minRange
//       minRange.value = Math.min(clickedValue, maxRange.value - gap);
//       updateMin();
//     } else {
//       // Move maxRange
//       maxRange.value = Math.max(clickedValue, minRange.value + gap);
//       updateMax();
//     }
//   });

//   updateSliderTrack();
// }
// rangeslider();





document.addEventListener("DOMContentLoaded", () => {
  const firstCard = document.querySelector(
    ".media--slider-effect:first-child > a"
  );
  let isAutoScrolling = true;
  let hasManualScroll = false;
  if (firstCard) {
    const totalWidth = firstCard.scrollWidth;
    const viewWidth = firstCard.clientWidth;
    const maxScrollLeft = totalWidth - viewWidth;
    const scrollDuration = 5000;
    const scrollStep = maxScrollLeft / (scrollDuration / 16);
    let scrollAmount = 0;
    function autoScroll() {
      if (isAutoScrolling && !hasManualScroll) {
        scrollAmount += scrollStep;
        if (scrollAmount >= maxScrollLeft) {
          scrollAmount = 0;
          isAutoScrolling = false;
        }
        firstCard.scrollLeft = scrollAmount;
      }
    }
    firstCard.addEventListener("scroll", () => {
      if (!isAutoScrolling) return;
      hasManualScroll = true;
    });
    const interval = setInterval(autoScroll, 16);
    firstCard.addEventListener("scroll", () => {
      if (!isAutoScrolling) clearInterval(interval);
    });
  }
});

function scrollToInitialState() {
  const $firstCard = $(".media--slider-effect:first-child > a");
  if ($firstCard.length) {
    $firstCard.scrollLeft(0);
  }
}

$(document).ready(function () {
  const $progressBar = $(".progress-bar-progress");
  const $slider = $(".product_slider_images");

  const calculateInitialPercentage = () => {
    const sliderHeight = $slider.height() || 1;
    const scrollHeight = $slider.prop("scrollHeight") || 1;
    return (sliderHeight / scrollHeight) * 100;
  };

  const initializeSliderHeight = () => {
    const $firstImage = $slider.find("img").first();
    if ($firstImage.length) {
      const setHeight = () => {
        const imgHeight = $firstImage.height();
        $slider.height(imgHeight);

        const initialPercentage = calculateInitialPercentage();
        $progressBar.css({
          height: `${initialPercentage}%`,
          "background-color": "black",
        });
      };

      if ($firstImage[0].complete) {
        setHeight();
      } else {
        $firstImage.on("load", setHeight);
      }
    }
  };

  const updateProgressBar = () => {
    const initialPercentage = calculateInitialPercentage();
    const scrollTop = $slider.scrollTop() || 0;
    const sliderHeight = $slider.height() || 1;
    const scrollHeight = $slider.prop("scrollHeight") || 1;

    const scrollPercentage =
      ((scrollTop / (scrollHeight - sliderHeight)) * (100 - initialPercentage)) +
      initialPercentage;

    $progressBar.css({
      height: `${scrollPercentage}%`,
    });
  };

  initializeSliderHeight();
  $slider.on("scroll", updateProgressBar);
});






$(".readmore").click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector(".product-description-full");
  descriptionFull.style.display = "block";
  var descriptionShort = document.querySelector(".product-description-short");
  descriptionShort.style.display = "none";
});
$(".readless").click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector(".product-description-full");
  descriptionFull.style.display = "none";
  var descriptionShort = document.querySelector(".product-description-short");
  descriptionShort.style.display = "block";
});



$(document).ready(function () {
  if ($(window).width() < 749) {
    $(".accordiondescription").first().addClass("first_class").end().last().addClass("last_class");
    $(document).on("click", ".accordion_headings", function () {
      var $accordion = $(this).next(".accordion_paragraph");
      var $parentAccordion = $(this).closest(".accordiondescription");

      // Toggle the active class
      $parentAccordion.toggleClass("active");

      // Toggle aria-expanded on the clicked heading
      var isExpanded = $(this).attr("aria-expanded") === "true";
      $(this).attr("aria-expanded", !isExpanded);

      var dynamicHeight = $accordion[0].scrollHeight + "px";
      var maxHeight = "calc(" + dynamicHeight + " + 16px * 2)";
      
      if ($parentAccordion.hasClass("active")) {
        // Calculate and set max-height dynamically
        $accordion.css({
          maxHeight: maxHeight,
          opacity: 1,
          visibility: "visible",
          paddingTop: "16px",
          paddingBottom: "16px"
        });
      } else {
        // Collapse the accordion
        $accordion.css({
          maxHeight: "0px",
          opacity: 0,
          visibility: "hidden",
          paddingTop: "0px",
          paddingBottom: "0px"
        });
      }

      // Close other open accordions
      // $('.accordiondescription').not($parentAccordion).removeClass('active')
      //   .find('.accordion_paragraph').css({
      //     maxHeight: "0px",
      //     opacity: 0,
      //     visibility: "hidden",
      //     paddingTop: "0px",
      //     paddingBottom: "0px"
      //   });
    });
  }
});



$(document).ready(function () {
  // Listen for changes on <details>
  $("details").on("toggle", function () {
    var $details = $(this);
    var $linkmenu = $details.find(".menu-drawer__inner-submenu");

    if ($details.attr("open")) {
      // Calculate dynamic height of the content for #link-woman
      var dynamicHeight = $linkmenu[0]?.scrollHeight + "px" || "0px";
      var maxHeight = "calc(" + dynamicHeight + " + 6px * 2)";

      // Apply styles for the open state for #link-woman
      $linkmenu.css({
        opacity: 1,
        maxHeight: maxHeight,
        paddingTop: "6px",
        paddingBottom: "6px",
        visibility: "visible"
      });

    } else {
      // Apply styles for the closed state for #link-woman
      $linkmenu.css({
        opacity: 0,
        maxHeight: "0px",
        paddingTop: "0px",
        paddingBottom: "0px",
        visibility: "hidden"
      });
    }
  });
});

$(document).ready(function () {
  if ($(window).width() < 749) {
    const $footerBlocks = $('.footer-block');

    // Add initial CSS styles
    $('.footer-block__details-content').css({
      opacity: 0,
      maxHeight: '0px',
      paddingTop: '0px',
      paddingBottom: '0px',
      paddingLeft: '10px',
      paddingRight: '10px',
      visibility: 'hidden',
      overflow: 'hidden',
      transition: 'opacity 0.6s ease, max-height 0.6s ease, padding 0.6s ease, visibility 0.6s ease',
    });

    // Event delegation for .footer-block__heading
    $(document).on('click', '.footer-block__heading', function (event) {
      event.stopPropagation(); // Prevent interference from other event handlers
      const $parentAccordion = $(this).closest('.footer-block');
      const $accordion = $parentAccordion.find('.footer-block__details-content');

      // Toggle the active class
      $parentAccordion.toggleClass('active');

      // Toggle aria-expanded on the clicked heading
      const isExpanded = $(this).attr('aria-expanded') === 'true';
      $(this).attr('aria-expanded', !isExpanded);

      // Apply styles for active state
      if ($parentAccordion.hasClass('active')) {
        $accordion.css({
          opacity: 1,
          maxHeight: 'calc(88px + 16px * 2)',
          paddingTop: '16px',
          paddingBottom: '16px',
          visibility: 'visible',
        });
      } else {
        $accordion.css({
          opacity: 0,
          maxHeight: '0px',
          paddingTop: '0px',
          paddingBottom: '0px',
          visibility: 'hidden',
        });
      }

      // Close other open accordions
      $footerBlocks.not($parentAccordion).removeClass('active').find('.footer-block__details-content').css({
        opacity: 0,
        maxHeight: '0px',
        paddingTop: '0px',
        paddingBottom: '0px',
        visibility: 'hidden',
      });

      // Reset aria-expanded for other headings
      $footerBlocks.not($parentAccordion).find('.footer-block__heading').attr('aria-expanded', 'false');
    });

    // Ensure .product-add-to-cart__button logic does not interfere
    $(document).on('click', '.product-add-to-cart__button', function (event) {
      event.stopPropagation(); // Prevent it from interfering with other click handlers
    });
  }
});


$(document).ready(function() {
  if ($(window).width() <= 749) {
    if ($('body').hasClass('template_customers/login') || 
        $('body').hasClass('template_customers/register') || 
        $('body').hasClass('template_customers/account')) {
      $('#search_bar').css('display', 'none');
    }
  }
});



(function () {
  function onAccountPage() {
    const c = document.body.className;
    return (
      /template[-_/]?customers[-_/]?account/.test(c) ||
      location.pathname.startsWith('/account')
    );
  }
  if (!onAccountPage()) return;
  function waitForElement(selector, { root = document, timeout = 15000 } = {}) {
    return new Promise((resolve, reject) => {
      const el = root.querySelector(selector);
      if (el) return resolve(el);
      const observer = new MutationObserver(() => {
        const found = root.querySelector(selector);
        if (found) {
          observer.disconnect();
          resolve(found);
        }
      });
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
      if (timeout) {
        setTimeout(() => {
          observer.disconnect();
          reject(new Error(`Timeout waiting for ${selector}`));
        }, timeout);
      }
    });
  }
  function renderClock(into) {
    if (!into || into.querySelector('#clock')) return;

    const clockDiv = document.createElement('div');
    clockDiv.id = 'clock';
    clockDiv.style.display = 'flex';
    clockDiv.style.alignItems = 'center';
    clockDiv.style.gap = '8px';

    const clockIcon = document.createElement('span');
    clockIcon.innerHTML = `
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
           xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M12 0C5.372 0 0 5.372 0 12s5.372 12 12 12 12-5.372 12-12S18.628 0 12 0Zm0 22.8A10.8 10.8 0 1 1 22.8 12 10.812 10.812 0 0 1 12 22.8Z" fill="currentColor"/>
        <path d="M12.6 6.6h-1.2V12.6H17.4v-1.2H12.6V6.6Z" fill="currentColor"/>
      </svg>
    `;

    const clockTime = document.createElement('span');
    clockTime.id = 'clock-time';

    clockDiv.append(clockIcon, clockTime);
    into.appendChild(clockDiv);
    function updateClock() {
      const el = clockTime;
      if (!el) return;
      const now = new Date();
      let h = now.getHours();
      const m = now.getMinutes();
      const s = now.getSeconds();
      const ampm = h >= 12 ? 'PM' : 'AM';
      h = h % 12 || 12;
      const pad = (n) => n.toString().padStart(2, '0');
      el.textContent = `${pad(h)}:${pad(m)}:${pad(s)} ${ampm}`;
    }
    updateClock();
    setInterval(updateClock, 1000);
  }
  function boot() {
    waitForElement('.frcp-nav__title', { timeout: 15000 })
      .then((host) => renderClock(host))
      .catch(() => {
        console.warn('Element .frcp-nav__title not found after waiting. Confirm selector or app markup.');
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();


document.addEventListener('DOMContentLoaded', function() {
  function wrapFirstWord(selector) {
    var lookbookLink = document.querySelector(selector);
    if (lookbookLink) {
      var text = lookbookLink.textContent.trim();
      
      var firstWord = text.split(' ')[0];
      var restOfText = text.substring(firstWord.length);
  
      lookbookLink.innerHTML = '<span class="first-word">' + firstWord + '</span>' + restOfText;
    }
  }

  wrapFirstWord('a#HeaderDrawer-woman-lookbook');
  wrapFirstWord('a#HeaderDrawer-man-lookbook');

  var style = document.createElement('style');
  style.innerHTML = `
    .first-word {
      font-size: 6px;
      line-height: 6px;
      padding-right: 4px;
      align-self: flex-start;
      font-stretch: normal;
      font-weight: inherit;
      letter-spacing: 1px;
      text-transform: uppercase;
      vertical-align: top;
    }
  `;
  document.head.appendChild(style);
});


document.addEventListener('DOMContentLoaded', function() {
    var element = document.querySelector('.right-content');
    if (element) {
        element.style.display = 'none';
    }
});

$('.sameclass').on('click', function(){
  $(this).addClass('active').siblings().removeClass('active');
})


document.addEventListener('DOMContentLoaded', () => {
    let modalInitialized = false;

    const initProductModal = () => {
        if (!modalInitialized) {
            modalInitialized = true;

            // Dynamically load modal functionality
            const modalScript = document.createElement('script');
            modalScript.src = '{{ "product-modal.js" | asset_url }}';
            modalScript.onload = () => {
                console.log('Product modal loaded');
            };
            document.body.appendChild(modalScript);
        }
    };

    const imageBarItems = document.querySelectorAll('.product-detail-images__image-barone li');

    // Add event listeners for click or touch events
    imageBarItems.forEach(item => {
        item.addEventListener('click', initProductModal);
        item.addEventListener('touchstart', initProductModal, { passive: true });
    });
});

document.addEventListener('DOMContentLoaded', () => {
  if (document.body.classList.contains('template_search')) return;
  autocompletelistener();
});





// (function () {
//   const DEFAULT_TEXT = 'Pending';
//   const STATUS_MAP = {
//     'manifested': { cls: 'frcp-order__status--manifested', text: 'Manifested' },
//     'intransit': { cls: 'frcp-order__status--intransit', text: 'In Transit' },
//     'in_transit': { cls: 'frcp-order__status--intransit', text: 'In Transit' },
//     'delivered': { cls: 'frcp-order__status--delivered', text: 'Delivered' },
//     'returned': { cls: 'frcp-order__status--returned', text: 'Returned' },
//     'cancelled': { cls: 'frcp-order__status--cancelled', text: 'Cancelled' },
//     'pending': { cls: 'frcp-order__status--pending', text: 'Pending' },
//     'unknown': { cls: 'frcp-order__status--pending', text: 'Pending' }
//   };

//   function normalizeStatus(s) {
//     if (!s) return '';
//     return String(s).trim().toLowerCase().replace(/\s+/g, '').replace(/[^a-z0-9_]/g, '');
//   }

//   function createStatusElement(rawStatus) {
//     const key = normalizeStatus(rawStatus) || 'unknown';
//     const mapping = STATUS_MAP[key] || STATUS_MAP['unknown'];
//     const div = document.createElement('div');
//     div.className = 'frcp-order__status ' + mapping.cls;
//     div.setAttribute('aria-live', 'polite');
//     div.textContent = mapping.text;
//     return div;
//   }

//   function updateOrderBlock(orderBlock) {
//     if (!orderBlock) return;
//     const wrapper = orderBlock.querySelector('.frcp-order__status-wrapper');
//     if (!wrapper) return;

//     // prefer pre-rendered data attribute
//     const metaStatus = orderBlock.getAttribute('data-order-status') || '';

//     // If existing status already matches what we'd set, do nothing
//     const existing = wrapper.querySelector('.frcp-order__status');
//     if (existing) {
//       const existingText = existing.textContent && existing.textContent.trim();
//       const desiredText = (STATUS_MAP[normalizeStatus(metaStatus)] || STATUS_MAP['unknown']).text || DEFAULT_TEXT;
//       if (existingText === desiredText) return; // no change required
//     }

//     // remove existing status elements (but be gentle)
//     wrapper.querySelectorAll('.frcp-order__status').forEach(el => el.remove());

//     // create & insert new element
//     const newStatusEl = createStatusElement(metaStatus || DEFAULT_TEXT);
//     const financial = wrapper.querySelector('.frcp-order__financial-status');
//     if (financial) wrapper.insertBefore(newStatusEl, financial);
//     else wrapper.appendChild(newStatusEl);
//   }

//   function runUpdate() {
//     const blocks = document.querySelectorAll('.frcp-order__info');
//     blocks.forEach(updateOrderBlock);
//   }

//   // run once on DOM ready
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', runUpdate);
//   } else {
//     runUpdate();
//   }

//   // Safe MutationObserver: watch only a narrow container if present
//   const parent = document.querySelector('#orders-list') || document.querySelector('.orders-list') || document.body;
//   let debounceTimer = 0;
//   const observer = new MutationObserver((mutations) => {
//     if (debounceTimer) return;
//     debounceTimer = setTimeout(() => {
//       debounceTimer = 0;
//       runUpdate();
//     }, 300); // run at most once every 300ms
//   });

//   observer.observe(parent, { childList: true, subtree: true });

//   // expose for debugging / immediate disconnect
//   window.__frcp_status_mo = observer;
//   window.__frcp_status_updateNow = runUpdate;
// })();



// (function () {
//   const origRemove = Element.prototype.remove;
//   Element.prototype.remove = function () {
//     if (this.classList && this.classList.contains('frcp-toast-wrapper')) {
//       console.log('[toast] prevent auto-removal');
//       return; // skip removal
//     }
//     return origRemove.call(this);
//   };
// })();



